/* eslint-disable import/no-cycle */
/* eslint-disable no-restricted-syntax */
import { fromJS } from "immutable";
import ActionTypes from "../../constants/action-types";
import AppConfig from "../../constants/config";
import content from "../../constants/content";
import triggerSimpleAjax from "../../helper/httpHelper";
import { projectMigrationHelper } from "../../helper/jsonMigrationHelper";
import proceedWait from "../../helper/proceedWait";
import uuid, { randomString } from "../../helper/uuid";
import { addNotification } from "./notificationUtils";
import { addCordsToSubtitle, updateAutoSubtitle } from "./subtitleUtils";
import { removeInvalidProjectKeys } from "../../helper/projectValidation";
import { getTextBounds } from "../../containers/text/TextHelper";
import { getSubtitlesFontToLoad, loadSubtitleFontFamily } from "../../helper/fontLoadHelper";
import { updateIntroOutroText, applyFlipInitial, aiProjectUpdate, setReframeData } from "./appUtils";
// import { getRandomInt } from "../../helper/formateDate";
import openUrl from "../../helper/openUrl";
import { sendSocketMessage } from "../../socket";
import socketChannels from "../../constants/socket-channels";
import { createNewReframe } from "../../helper/reframeHelper";
// import sampledata from "../../containers/timeline/sampledata.json";

const { API_URL, API } = AppConfig;

export const saveProject = (projectId, details) => {
  return new Promise((res, rej) => {

    triggerSimpleAjax(
      `${API_URL}${API.SAVE_PROJECT_REST}`,
      "POST",
      false,
      {
        projectId,
        data: removeInvalidProjectKeys(details),
      },
      (args) => {
        res(args);
      },
      (err) => {
        rej(err);
      }
    );
  });
};

export function getReframeData(payload) {
  return new Promise((resolve, reject) => {
    const onSuccess = async (res) => {
      if (res.status === "error") {
        return reject(new Error(content.FAILED_TO_LOAD_SUBTITLE_DATA))
      }
      return resolve(res);
    };
    const onError = () =>
      reject(new Error("Failed to load reframe data"));
    triggerSimpleAjax(
      `${API_URL}${API.REFRAME_ASSETS}`,
      "POST",
      false,
      payload,
      onSuccess,
      onError
    );
  });
}

export async function getSubtitleData(params) {
  const { subtitleId, projectId } = params;
  return new Promise((resolve, reject) => {
    const body = { subtitleId, projectId };
    const onSuccess = async (res) => {
      if (res.status === "error") {
        return reject(new Error(content.FAILED_TO_LOAD_SUBTITLE_DATA))
      }
      return resolve(res);
    };
    const onError = () =>
      reject(new Error(content.FAILED_TO_LOAD_SUBTITLE_DATA));
    triggerSimpleAjax(
      `${API_URL}${API.SUBTITLE.GET}`,
      "POST",
      false,
      body,
      onSuccess,
      onError
    );
  });
}

/**
 * 
 * @param {[List]} subtitleList 
 * @param {{enterStart: number, exitEnd: number}} target 
 * @param {number} left 
 * @param {number} right 
 * @param {[number]} result 
 * @returns {[number]}
 */
const findIndexes = (subtitleList, target, left, right, result = []) => {
  if (left > right) return result;

  const mid = Math.floor((left + right) / 2);

  /**
   * @type {{enterStart: number, exitEnd: number}}
   */
  const midSubtitle = subtitleList.get(mid);

  const inBtwn = midSubtitle.get("enterStart") >= target.enterStart && midSubtitle.get("exitEnd") <= target.exitEnd; // in between
  const leftX = midSubtitle.get("exitEnd") >= target.enterStart && midSubtitle.get("enterStart") <= target.enterStart; // left intersection
  const rightX = midSubtitle.get("enterStart") <= target.exitEnd && midSubtitle.get("exitEnd") >= target.exitEnd; // right intersection

  const searchThroughRight = target.exitEnd > midSubtitle.get("enterStart");

  if (inBtwn || leftX || rightX) {
    result.push(mid);
    findIndexes(subtitleList, target, left, mid - 1, result);
    findIndexes(subtitleList, target, mid + 1, right, result);
  } else if (searchThroughRight) {
    findIndexes(subtitleList, target, mid + 1, right, result); // Search right
  } else {
    findIndexes(subtitleList, target, left, mid - 1, result); // Search left
  }
  return result; // Return all valid indices
}

function updateExitEndIfRestricted(data) {
  if (data.workspaceItems) {
    Object.values(data.workspaceItems).forEach(item => {
      if (item.isRestrict) {
        item.exitStart = item.exitEnd;
        item.exitEnd = item.maxDuration;
      }
    });
  }
  return data;
}

export function setProjectDetails(id, userResponse, isApp = false, isPublish = false) {
  const apiUrl = `${API_URL}${isApp ? API.GET_PROJECT : isPublish ? API.GET_RENDER_PROJECT : API.PREVIEW_PROJECT}`;

  return (dispatch, getState) => {
    const noPermission = async (access, url) => {
      dispatch(
        addNotification({
          id: uuid(),
          toastType: "WARNING",
          description: `You don't have ${access} access to this project.`,
        })
      );
      await proceedWait(2000);
      window.location.href = `${url}`;
    };
    return new Promise((res, rej) => {
      triggerSimpleAjax(
        apiUrl,
        "POST",
        true,
        { [isPublish ? "exportid" : "projectId"]: id },
        async (response) => {
          let { permission } = response;
          const { modified } = response;
          permission = isPublish ? 1 : permission
          const { project, subtitle_data: subtitleData, projectId = "" } = response;
          if (!project) {
            openUrl(`${API_URL}preview/${id}`, true);
            return;
          }
          const { width, height } = project;
          let titleTextPayLoad;
          const { titletext } = project.workspaceItems || {};
          const isRectNotFit = Object.keys(project.workspaceItems || {}).some((key) => {
            const ele = project.workspaceItems[key];
            return ele.type === "SHAPE" && ele.mappingTextId && ele.height === null
          })
          if (titletext) {
            const { isVerified } = titletext.textData.formats.others; /** @desc for the first time we verify if the titleText is properly fit to the space */
            if (!isVerified) {
              const maxWidth = titletext.width;
              const { family: fontFamilyName } = titletext.textData.formats.others;
              const { fontFamily } = titletext.textData.formats.containerStyle;
              const textData = {
                fontFamilyName, fontFamily,
                others: {
                  isUserFont: titletext.textData.formats.others.isUserFont,
                  cssUrl: titletext.textData.formats.others.cssUrl
                }
              }
              const fontToLoad = getSubtitlesFontToLoad(undefined, fromJS([]), textData);
              if (fontToLoad.length) {
                const sampleText = titletext.textData.htmlText;
                await loadSubtitleFontFamily(fontToLoad, sampleText);
              }
              const textBounds = getTextBounds(fromJS(titletext.textData), maxWidth);
              const paddOffSet = 15;
              const newY = (height / 2) - (textBounds.height / 2) - paddOffSet;
              const newHeight = textBounds.height + paddOffSet * 2;
              titletext.textData.formats.others.isVerified = true;
              const shapeProps = {};
              if (titletext.type === "SHAPE") {
                shapeProps.yRatio = (((newHeight / 2) - textBounds.height / 2) / newHeight) * 100;
                shapeProps.heightRatio = (textBounds.height / newHeight) * 100;
              }
              project.workspaceItems.titletext = { ...titletext, y: newY, height: newHeight, ...shapeProps };
              const { x, y, width: txtWidth, height: txtHeight } = project.workspaceItems.titletext;
              titleTextPayLoad = {
                container: "workspaceItems",
                selectedItem: "titletext",
                isTyping: false,
                toUpdate: {
                  textData: titletext.textData,
                  x, y, width: txtWidth, height: txtHeight,
                  ...shapeProps
                }
              }
            }
          }

          const output = project.reframeData || {};
          const reframeFetchPromises = [];
          const loadedAssetIds = new Set();

          const mergeReframeData = (out, targetKey, data) => {
            if (!data) return;
            if (!out[targetKey]) {
              out[targetKey] = JSON.parse(JSON.stringify(data));
            } else if (data.scenes) {
              if (!out[targetKey].scenes) out[targetKey].scenes = [];
              const existingSceneIds = new Set(out[targetKey].scenes.map((s) => s.id || s.sceneId || s.scene_id));
              const newScenes = (data.scenes || []).filter((s) => !existingSceneIds.has(s.id || s.sceneId || s.scene_id));
              out[targetKey].scenes = [...out[targetKey].scenes, ...newScenes];
            }
          };



          // 1. Fetch from workspace items
          Object.keys(project.workspaceItems || {}).forEach((key) => {
            const item = project.workspaceItems[key];
            if (item?.isReframe && item.reframeSrc) {
              const { assetId, reframeSrc: src, dropId } = item;
              let compositeKey = null;
              if (dropId) {
                const [shortId] = dropId.split("_");
                if (shortId && shortId.startsWith("short")) {
                  compositeKey = `${assetId}_${shortId}`;
                }
              }

              if (typeof src === "string" && src.startsWith("http")) {
                 reframeFetchPromises.push(
                  fetch(src)
                    .then((res) => res.json())
                    .then((json) => {
                      if (json && typeof json === "object") {
                        loadedAssetIds.add(assetId);
                        if (compositeKey) {
                          mergeReframeData(output, compositeKey, json);
                        }
                        mergeReframeData(output, assetId, json);
                      }
                    })
                    .catch((err) => {
                      console.error(`Failed to fetch reframe data for assetId ${assetId}:`, err);
                    })
                );
              } else if (src && typeof src === "object") {
                loadedAssetIds.add(assetId);
                if (compositeKey) {
                  mergeReframeData(output, compositeKey, src);
                }
                mergeReframeData(output, assetId, src);
              }
            }
          });

          // 2. Fetch from project.shorts (covers cases where workspace items are missing reframeSrc)
          if (project.shorts) {
            Object.values(project.shorts).forEach((short) => {
              if (short) {
                const shortId = short.id || "";
                const clipsList = short.clips || [];
                if (clipsList.length > 0) {
                  clipsList.forEach((clip) => {
                    if (clip && clip.isReframe && clip.reframeSrc) {
                      const src = clip.reframeSrc;
                      const baseVideoKey = Object.keys(project.workspaceItems || {}).find(
                        (k) => project.workspaceItems[k]?.type === "UPVIDEO"
                      );
                      const assetId = baseVideoKey ? project.workspaceItems[baseVideoKey]?.assetId : null;
                      if (assetId && typeof src === "string" && src.startsWith("http")) {
                        const compositeKey = `${assetId}_${shortId}`;



                        reframeFetchPromises.push(
                          fetch(src)
                            .then((res) => res.json())
                            .then((json) => {

                              if (json && typeof json === "object") {
                                loadedAssetIds.add(assetId);
                                mergeReframeData(output, compositeKey, json);
                                mergeReframeData(output, assetId, json);
                              }
                            })
                            .catch((err) => {
                              console.error(`Failed to fetch reframe data for short clip:`, err);
                            })
                        );
                      }
                    }
                  });
                } else if (short.isReframe && short.reframeSrc) {
                  const src = short.reframeSrc;
                  const baseVideoKey = Object.keys(project.workspaceItems || {}).find(
                    (k) => project.workspaceItems[k]?.type === "UPVIDEO"
                  );
                  const assetId = baseVideoKey ? project.workspaceItems[baseVideoKey]?.assetId : null;
                  if (assetId && typeof src === "string" && src.startsWith("http")) {
                    const compositeKey = `${assetId}_${shortId}`;


                    reframeFetchPromises.push(
                      fetch(src)
                        .then((res) => res.json())
                        .then((json) => {

                          if (json && typeof json === "object") {
                            loadedAssetIds.add(assetId);
                            mergeReframeData(output, compositeKey, json);
                            mergeReframeData(output, assetId, json);
                          }
                        })
                        .catch((err) => {
                          console.error(`Failed to fetch reframe data for fallback short:`, err);
                        })
                    );
                  }
                }
              }
            });
          }

          if (reframeFetchPromises.length > 0) {
            try {
              await Promise.all(reframeFetchPromises);
              project.reframeData = output;
              dispatch(setReframeData(output));
            } catch (err) {
              // silently fail
            }
          }

          const assetIds = [];
          Object.keys(project.workspaceItems || {}).forEach((key) => {
            const item = project.workspaceItems[key];
            if (item?.isReframe && !assetIds.includes(item.assetId) && !loadedAssetIds.has(item.assetId)) {
              assetIds.push(item.assetId);
            }
          });

          if (assetIds.length > 0) {
            try {
              const result = await getReframeData({ assets: assetIds });
              const { reframe } = result || {};
              for (const [key, value] of Object.entries(reframe || {})) {
                const url = value;
                const response = await fetch(url);
                const json = await response.json();

                mergeReframeData(output, key, json);

                // Also populate composite keys for matching items
                Object.keys(project.workspaceItems || {}).forEach((itemKey) => {
                  const item = project.workspaceItems[itemKey];
                  if (item?.assetId === key && item.dropId) {
                    const [shortId] = item.dropId.split("_");
                    if (shortId && shortId.startsWith("short")) {
                      mergeReframeData(output, `${key}_${shortId}`, json);
                    }
                  }
                });
              }
              project.reframeData = output;
              dispatch(setReframeData(output));
            } catch (err) {
              dispatch(
                addNotification({
                  id: uuid(),
                  toastType: "WARNING",
                  description: err.message || content.WENT_WRONG,
                })
              );
            }
          }

          // Create scene clips for any reframed video item that doesn't have them yet
          const url = window.location.pathname;
          const queryProjectId = url.split("/").pop();
          // Treat any non-preview, non-shorts page as a candidate for reframe scene creation.
          // This ensures `sceneData` is generated on editor, render, and publish/export pages
          // (previously it ran only on editor pages which caused missing scenes when
          // navigating from Shorts -> Render).
          const shouldCreateScenes = !url.includes("preview") && !url.includes("shorts");

          if (shouldCreateScenes) {
            try {
              let hasNewScenesCreated = false;
              const updatedWorkspaceItems = {
                project: {
                  ...project,
                  // Preserve reframeData in the save. Without it, this save wipes the
                  // persisted layout on the backend, so the next load rebuilds reframeData
                  // from the original AI-reframe JSON and the reconciliation below reverts
                  // the layout (the "reverts on second refresh" bug).
                  reframeData: output,
                  workspaceItems: {
                    ...project.workspaceItems
                  }
                }
              };

              // Resolve the scene_id a scene child belongs to (child.sceneId is like "scene<scene_id>")
              const getChildSceneId = (w) => {
                if (w?.sceneData && w.sceneData.scene_id) return w.sceneData.scene_id;
                if (typeof w?.sceneId === "string" && w.sceneId.startsWith("scene")) {
                  return w.sceneId.slice("scene".length);
                }
                return w?.sceneId;
              };

              for (const key of Object.keys(project.workspaceItems || {})) {
                const item = project.workspaceItems[key];
                if (item?.isReframe) {
                  const childrenForParent = Object.values(project.workspaceItems).filter(
                    (w) => (w?.originalId === item?.id || w?.dropId === item?.id) && (w?.sceneData || w?.sceneId)
                  );
                  const originalExists = childrenForParent.length > 0;

                  // reconciliation — the workspace items are the source of truth for layout.
                  const isSplitReframeClip = Object.keys(project.workspaceItems || {}).some(
                    (k) => k !== key &&
                      project.workspaceItems[k]?.isReframe &&
                      project.workspaceItems[k]?.assetId === item.assetId &&
                      !project.workspaceItems[k]?.sceneData
                  );

                  // Build a scene_id -> layout map from the (correctly persisted) reframeData
                  const assetScenes = output[item.assetId]?.scenes || [];
                  const sceneLayoutById = {};
                  assetScenes.forEach((s) => {
                    if (s && s.scene_id !== undefined) sceneLayoutById[s.scene_id] = s.layout;
                  });

                 // SKIP for split clips: each split piece owns its layout independently.
                  const staleChildren = isSplitReframeClip ? [] : childrenForParent.filter((w) => {
                    const sid = getChildSceneId(w);
                    const expectedLayout = sceneLayoutById[sid];
                    return expectedLayout && w.layout && expectedLayout !== w.layout;
                  });
                  const layoutMismatch = staleChildren.length > 0;

                  if ((!originalExists || layoutMismatch) && output[item.assetId]) {
                    // When reconciling a layout change, drop the stale children first so the
                    // regenerated ones (with the correct person count / layout) replace them.
                    if (layoutMismatch) {
                      childrenForParent.forEach((w) => {
                        if (w?.id) {
                          delete project.workspaceItems[w.id];
                          delete updatedWorkspaceItems.project.workspaceItems[w.id];
                        }
                      });
                    }
                    const toUpdate = await createNewReframe(
                      fromJS(item),
                      output[item.assetId],
                      project.width,
                      project.height,
                      item.videoStart,
                      item.videoEnd,
                      "shorts"
                    );
                    if (toUpdate && toUpdate.length > 0) {
                      toUpdate.forEach((updateItem) => {
                        const newItemId = updateItem.id || randomString("reframe");
                        // Add to Redux memory project object
                        project.workspaceItems[newItemId] = updateItem.newItemData;
                        // Add to the backend update project object
                        updatedWorkspaceItems.project.workspaceItems[newItemId] = updateItem.newItemData;
                      });
                      hasNewScenesCreated = true;
                    }
                  }
                }
              }

              if (hasNewScenesCreated) {
                aiProjectUpdate({ projectId: project.projectid || queryProjectId, projectJson: updatedWorkspaceItems });
              }
            } catch (err) {
              // silently fail
            }
          }

          if (subtitleData && subtitleData.length) {
            const defaultSubtitle = subtitleData.find(
              (subtitle) => subtitle.isActive !== false
            );
            try {
              const result = await getSubtitleData({
                projectId: isPublish ? projectId : id,
                subtitleId: defaultSubtitle.subtitleId,
              });
              project.subtitle = result.subtitle;
              project.defaultSubtitle = defaultSubtitle.subtitleId;
              project.subtitleData = subtitleData;
              let hasValidCords = false;
              let isAllEmpty = true;
              for (const [, subtitleMap] of Object.entries(result.subtitle.data)) {
                for (const [, subtitleItem] of Object.entries(subtitleMap)) {
                  isAllEmpty = false;
                  if (Number.isFinite(subtitleItem.x) && Number.isFinite(subtitleItem.y) && Number.isFinite(subtitleItem.width) &&
                    Number.isFinite(subtitleItem.height) && subtitleItem.width !== 0 && subtitleItem.height !== 0) {
                    hasValidCords = true;
                    break;
                  }
                }
              }
              if (!hasValidCords && !isAllEmpty) {
                const { updatedSubtitles, textStyles, textEffects } =
                  await addCordsToSubtitle(result.subtitle, {
                    loadedFonts: fromJS([]),
                    workspaceWidth: width,
                    workspaceHeight: height,
                  });
                await updateAutoSubtitle(
                  updatedSubtitles,
                  isPublish ? projectId : id,
                  defaultSubtitle.subtitleId,
                  textStyles,
                  textEffects,
                  Boolean(result.subtitle.position)
                );
                project.subtitle.data = updatedSubtitles.toJS();
                delete project.subtitle.position;
              }
            } catch (err) {
              project.subtitle = undefined;
              dispatch(
                addNotification({
                  id: uuid(),
                  toastType: "WARNING",
                  description: err.message || content.WENT_WRONG,
                })
              );
            }
          }
          if (isRectNotFit) {
            const shapeItems = Object.keys(project.workspaceItems).filter(key => {
              const ele = project.workspaceItems[key];
              return ele.type === "SHAPE" && ele.mappingTextId && ele.height === null;
            });
            const textItems = Object.keys(project.workspaceItems).filter(key => {
              const ele = project.workspaceItems[key];
              return ele.type === "TEXT" && shapeItems.find(shape => project.workspaceItems[shape].mappingTextId === ele.id);
            });

            for (const key of shapeItems) {
              const shapeEle = project.workspaceItems[key];
              const mappingText = textItems.map(textKey => project.workspaceItems[textKey]).find(text => text.id === shapeEle.mappingTextId);
              if (mappingText) {
                const { width } = project;
                const maxWidth = width;
                const { family: fontFamilyName } = mappingText.textData.formats.others;
                const { fontFamily } = mappingText.textData.formats.containerStyle;
                const textData = {
                  fontFamilyName, fontFamily,
                  others: {
                    isUserFont: mappingText.textData.formats.others.isUserFont,
                    cssUrl: mappingText.textData.formats.others.cssUrl
                  }
                }
                const fontToLoad = getSubtitlesFontToLoad(undefined, fromJS([]), textData);
                await loadSubtitleFontFamily(fontToLoad, mappingText.textData.htmlText);
                const textBounds = getTextBounds(fromJS(mappingText.textData), maxWidth);
                const paddOffSet = 20;
                const newHeight = textBounds.height + paddOffSet * 2;
                mappingText.textData.formats.others.isVerified = true;
                const shapeProps = {};
                // eslint-disable-next-line no-alert
                if (shapeEle.type === "SHAPE") {
                  shapeProps.yRatio = (((newHeight / 2) - textBounds.height / 2) / newHeight) * 100;
                  shapeProps.heightRatio = (textBounds.height / newHeight) * 100;
                  shapeProps.height = newHeight;
                }
                project.workspaceItems[key] = { ...shapeEle, ...shapeProps };
                sendSocketMessage(socketChannels.S_MOVE_UPDATE, {
                  data: {
                    currentContainer: "workspaceItems",
                    workspaceChildren: {},
                    workspaceItems: {
                      [shapeEle.id]: {
                        height: shapeProps.height
                      }
                    }
                  }
                });
              }
            }
          }
          let dimensionName = "";
          if (width > height) {
            dimensionName = "horizontal";
          } else if (width === height) {
            dimensionName = "square";
          } else {
            dimensionName = "vertical";
          }
          let projectData;
          if (project.scenes?.length) {
            projectData = projectMigrationHelper(project);
            saveProject(isPublish ? projectId : id, projectData).then(() => {
              dispatch({
                type: ActionTypes.ADD_NOTIFICATION,
                payload: {
                  id: uuid(),
                  toastType: "SUCCESS",
                  description: "Project has been Migrated successfully.",
                },
              });
            });
          } else {
            projectData = project;
          }

          const applyFlipItems = [];
          const workspaceItemsLs = Object.entries(projectData.workspaceItems);
          let hasNullCordsTexts = false; // text Items with null cordinates [can be emojis 😃]
          if (workspaceItemsLs.length) {
            hasNullCordsTexts = workspaceItemsLs.some(([key, value]) => {
              if (key !== "titletext") {
                const { x, y, type, yLoc, xLoc } = value;
                if (type === "TEXT" && (yLoc !== undefined && yLoc !== null) && (xLoc !== undefined && xLoc !== null) && (x === null || y === null)) {
                  return true
                }
              }
              return false;
            });
          }

          projectData = updateExitEndIfRestricted(projectData);

          if (isApp && !permission) {
            noPermission("edit", `${window.location.origin}/preview/${id}`);
          }
          dispatch({
            type: ActionTypes.SET_USER_DATA,
            payload: {
              isLoggedIn: true,
              projectId: isPublish ? projectId : id,
              dimensionName,
              permission,
              ...userResponse,
              modified
            },
          });
          dispatch({
            type: ActionTypes.SET_PROJECT,
            payload: {
              ...projectData,
            },
          });
          const localSubtitleList = getState().projectDetails.get("localSubtitle").toList();
          if (hasNullCordsTexts) {
            workspaceItemsLs.forEach(([key, value]) => {
              if (key !== "titletext") {
                const { x, y, type, yLoc, xLoc, textData } = value;
                if (type === "TEXT" && (yLoc !== undefined && yLoc !== null) && (xLoc !== undefined && xLoc !== null) && (x === null || y === null)) {
                  let result = [];
                  if (localSubtitleList.size)
                    result = findIndexes(localSubtitleList, { enterStart: value.enterStart, exitEnd: value.exitEnd }, 0,
                      localSubtitleList.size - 1, []);

                  const { width: itemWidth, height: itemHeight } = getTextBounds(fromJS(textData), width);
                  let newY;
                  if (result.length) {
                    const maxY = result.reduce((prevY, listIndex) => {
                      const subtitleY = localSubtitleList.getIn([listIndex, "y"]) || height * yLoc;
                      return Math.min(prevY, subtitleY);
                    }, Infinity)
                    newY = maxY - itemHeight - 5;
                  } else {
                    newY = height * yLoc - (itemHeight / 2);
                  }
                  const newX = width * xLoc - (itemWidth / 2);
                  const toUpdate = { x: newX, y: newY, width: itemWidth, height: itemHeight };
                  applyFlipItems.push({
                    container: "workspaceItems",
                    id: key,
                    data: toUpdate
                  })
                }
              }
            })
          }

          if (applyFlipItems.length) {
            dispatch(applyFlipInitial(applyFlipItems));
          }
          if (titleTextPayLoad) { /** @Note always keep the dispatch in the bottom */
            dispatch(updateIntroOutroText(titleTextPayLoad));
          }
          res(response);
        },
        async (error) => {
          if (!isApp) {
            noPermission("view", AppConfig.API_URL);
          }
          dispatch({
            type: ActionTypes.SET_USER_DATA,
            isLoggedIn: true,
            ...userResponse,
          });
          rej(error);
        }
      );
    });
  };
}

export const setUserPaymentDetails = (id) => {
  const apiUrl = `${API_URL}${API.USER_PROJECT_DETAILS}`;

  return (dispatch) =>
    new Promise((res, rej) => {
      triggerSimpleAjax(
        apiUrl,
        "POST",
        true,
        { projectId: id },
        (response) => {
          dispatch({
            type: ActionTypes.SET_PAYMENT_DETAILS,
            payload: { ...response },
          });
        },
        (err) => {
          dispatch(
            addNotification({
              id: uuid(),
              toastType: "WARNING",
              description:
                err.message || content.FAILED_TO_GET_USER_PROJECT_DETAILS,
            })
          );
          rej(err);
        }
      );
    });
};

export function setAnimoProjectDetails(id, isSubtitle) {
  const apiUrl = `${API_URL}${API.GET_ANIMO_PROJECT}`;
  return (dispatch) =>
    new Promise((res, rej) => {
      triggerSimpleAjax(
        apiUrl,
        "POST",
        true,
        {
          projectId: id,
        },
        async (response) => {
          const { project, subtitle_data: subtitleData } = response;
          const { width, height } = project;
          if (subtitleData && subtitleData.length) {
            const defaultSubtitle = subtitleData.find(
              (subtitle) => subtitle.isActive !== false
            );
            try {
              const result = await getSubtitleData({
                projectId: id,
                subtitleId: defaultSubtitle.subtitleId,
              });
              project.subtitle = result.subtitle;
              project.defaultSubtitle = defaultSubtitle.subtitleId;
              let hasValidCords = false;
              let isAllEmpty = true;
              for (const [, subtitleMap] of Object.entries(result.subtitle.data)) {
                for (const [, subtitleItem] of Object.entries(subtitleMap)) {
                  isAllEmpty = false;
                  if (Number.isFinite(subtitleItem.x) && Number.isFinite(subtitleItem.y) && Number.isFinite(subtitleItem.width) &&
                    Number.isFinite(subtitleItem.height) && subtitleItem.width !== 0 && subtitleItem.height !== 0) {
                    hasValidCords = true;
                    break;
                  }
                }
              }
              if (!hasValidCords && !isAllEmpty) {
                const { updatedSubtitles, textStyles, textEffects } =
                  await addCordsToSubtitle(result.subtitle, {
                    loadedFonts: fromJS([]),
                    workspaceWidth: width,
                    workspaceHeight: height,
                  });
                await updateAutoSubtitle(
                  updatedSubtitles,
                  id,
                  defaultSubtitle.subtitleId,
                  textStyles,
                  textEffects
                );
                project.subtitle.data = updatedSubtitles.toJS();
              }
            } catch (err) {
              project.subtitle = undefined;
              dispatch(
                addNotification({
                  id: uuid(),
                  toastType: "WARNING",
                  description: err.message || content.WENT_WRONG,
                })
              );
            }
          }
          dispatch({
            type: ActionTypes.SET_USER_DATA,
            payload: {
              isLoggedIn: true,
              projectId: id,
            },
          });
          dispatch({
            type: ActionTypes.SET_PROJECT,
            payload: {
              ...project,
            },
            isAnimoSubtitle: isSubtitle,
          });
          res(response);
        },
        (error) => {
          dispatch({
            type: ActionTypes.SET_USER_DATA,
            isLoggedIn: true,
          });
          dispatch(
            addNotification({
              id: uuid(),
              toastType: "WARNING",
              description:
                error.message || content.FAILED_TO_GET_PROJECT_DETAILS,
            })
          );
          rej(error);
        }
      );
    });
}

export function getUserDetails() {
  const apiUrl = `${API_URL}${API.USER_DETAILS}`;
  return new Promise((res, rej) => {
    triggerSimpleAjax(
      apiUrl,
      "POST",
      true,
      {},
      (response) => {
        res(response);
      },
      (error) => {
        rej(error);
      }
    );
  });
}

export function getCredits() {
  const apiUrl = `${API_URL}${API.GET_CREDITS}`;
  return (dispatch, getState) => new Promise((res, rej) => {
    let cc = "US"
    try {
      cc = getState().app.getIn(["ipConfig", "country_code"]);
    } catch (e) {
      cc = "US";
    }
    triggerSimpleAjax(
      apiUrl,
      "POST",
      true,
      {
        cc
      },
      (response) => {
        dispatch({
          type: ActionTypes.SET_CREDITS,
          payload: response,
        });
        res(response);
      },
      (error) => {
        rej(error);
      }
    );
  })
}

export function getTeamDetails() {
  const apiUrl = `${API_URL}${API.TEAM_DETAILS}`;
  return new Promise((res, rej) => {
    triggerSimpleAjax(
      apiUrl,
      "POST",
      true,
      {},
      (response) => {
        res(response);
      },
      (error) => {
        rej(error);
      }
    );
  });
}

export function switchTeam(dataT) {
  const apiUrl = `${API_URL}${API.SWITCH_TEAM}`;
  return new Promise((res, rej) => {
    triggerSimpleAjax(
      apiUrl,
      "POST",
      true,
      { dataT },
      (response) => {
        res(response);
      },
      (error) => {
        rej(error);
      }
    );
  });
}

export function getProjectInfo(id) {
  const apiUrl = `${API_URL}${API.GET_PROJECT_INFO}`;
  return (dispatch) => new Promise((res, rej) => {
    triggerSimpleAjax(
      apiUrl,
      "POST",
      true,
      {
        projectId: id
      },
      (response) => {
        dispatch({
          type: ActionTypes.SET_PROJECT_INFO,
          payload: { ...response }
        });
        res(response);
      },
      (e) => {
        rej(e);
      }
    );
  });
}

export async function insertSubtitle(reqBody) {
  return new Promise((resolve, reject) => {
    const onSuccess = async (res) => {
      if (!res.success) {
        return reject(new Error(content.FAILED_TO_IMPORT_SUBTITLE_DATA));
      }
      return resolve(res);
    };
    const onError = () =>
      reject(new Error(content.FAILED_TO_IMPORT_SUBTITLE_DATA));
    triggerSimpleAjax(
      `${API_URL}${API.SUBTITLE.INSERT}`,
      "POST",
      false,
      reqBody,
      onSuccess,
      onError
    );
  });
}

export function setJobtInfo(payload) {
  const apiUrl = `${API_URL}${API.UPDATE_JOB_INFO}`;
  return (dispatch) => new Promise((res, rej) => {
    triggerSimpleAjax(
      apiUrl,
      "POST",
      false,
      payload,
      (response) => {
        const { jobRequest } = response
        dispatch({
          type: ActionTypes.SET_PROJECT_INFO,
          payload: { jobRequest }
        });
        res(response);
      },
      (e) => {
        rej(e);
      }
    );
  });
}